export default __webpack_public_path__ + "static/media/2158.80169ad2.png";